import React from 'react';
import OnboardingCardSC, { CardTopSC } from './onboarding-card.styled';
import { BodyText } from '../../typography';
import InlineLoading from '../../ui/inline-loading';
import { ReactComponent as SuccesCheckIcon } from '../../../assets/img/svg/success-check.svg';
import { ReactComponent as WaitingClockIcon } from '../../../assets/img/svg/waiting-clock.svg';
import { ReactComponent as ErrorCheckIcon } from '../../../assets/img/svg/error-check.svg';
import { FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

const OnboardingCard = ({
  personalNumber,
  loading,
  isRefused,
  status,
  opened,
  children,
  headline,
  subtext,
  subtextDone,
  headlineDone,
  onRenderAction,
  className,
  hasInsurance,
}) => {
  useEffect(() => {
    if (onRenderAction !== null || onRenderAction !== undefined) {
      onRenderAction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <OnboardingCardSC className={className ? className : ''}>
      <CardTopSC className={className ? className : ''}>
        <div className={loading ? 'left-side loading' : 'left-side'}>
          {status === 'done' && headlineDone ? (
            <BodyText className={className === 'completed' ? 'bolder white' : 'bolder'}>
              <FormattedHTMLMessage id={headlineDone} defaultMessage={dlt[`${headlineDone}`]} />
            </BodyText>
          ) : (
            <BodyText className={isRefused ? 'bolder white' : 'bolder'}>
              <FormattedHTMLMessage id={headline} defaultMessage={dlt[`${headline}`]} />
            </BodyText>
          )}
          {status === 'done' && subtextDone ? (
            <BodyText
              className={
                isRefused
                  ? 'white bolder'
                  : className === 'completed'
                  ? 'grey bolder'
                  : 'black-transparent-lighter bolder'
              }
            >
              <FormattedHTMLMessage id={subtextDone} defaultMessage={dlt[`${subtextDone}`]} />{' '}
            </BodyText>
          ) : (
            subtext && (
              <BodyText className={`black-transparent-lighter bolder ${isRefused ? 'white' : ''}`}>
                <FormattedHTMLMessage id={subtext} defaultMessage={dlt[`${subtext}`]} />{' '}
                {personalNumber ? personalNumber : null}
              </BodyText>
            )
          )}
        </div>
        <div className="right-side">
          {loading ? <InlineLoading /> : null}
          {isRefused || hasInsurance === false ? (
            <ErrorCheckIcon />
          ) : status === 'done' ? (
            <SuccesCheckIcon />
          ) : (
            <WaitingClockIcon />
          )}
        </div>
      </CardTopSC>
      {opened ? <>{children}</> : null}
    </OnboardingCardSC>
  );
};

OnboardingCard.propTypes = {
  loading: PropTypes.bool,
  isRefused: PropTypes.bool,
  status: PropTypes.string,
  opened: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  headline: PropTypes.string,
  subtext: PropTypes.string,
  subtextDone: PropTypes.string,
  headlineDone: PropTypes.string,
  className: PropTypes.string,
};

OnboardingCard.defaultProps = {
  loading: false,
  isRefused: false,
  status: 'pending',
  opened: false,
  children: null,
  headline: '',
  subtext: '',
  subtextDone: '',
  headlineDone: '',
  className: '',
};

export default OnboardingCard;
